import { render, staticRenderFns } from "./EventsCard.vue?vue&type=template&id=4e2f3904&scoped=true&lang=pug"
import script from "./EventsCard.vue?vue&type=script&lang=js"
export * from "./EventsCard.vue?vue&type=script&lang=js"
import style0 from "./EventsCard.vue?vue&type=style&index=0&id=4e2f3904&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2f3904",
  null
  
)

export default component.exports